var swiperPd;
function GetSuggestedProducts() {
    return;

    if ($("#CurCatalogID").length > 0) {
        $.ajax({
            type: "GET",
            url: getRequestRoute() + "/p/ProductDetails/GetSuggestedProducts",
            data: "ProductID=" + $("#ProductID").val() + "&CurCatalogID=" + $("#CurCatalogID").val() + "&ColorID=" + $(".Colors .ColorOptionItem.active:first a").attr("data-id"),
            cache: false,
            success: function (dt) {
                dt = dt.replace("_buyuk", "_kucuk");

                console.log(dt);
                $(".js-suggested-product").append(dt);
                return;

                $(".AutoGetSuggested .AutoSetted").remove();

                if (dt != "") {
                    $(".AutoGetSuggested").append(dt);
                    $(".AutoGetSuggested .Productsuggest .ProductList").addClass("col-xs-24");
                }
            }
        });
    }
}

function SetLastVisitedProductsStorage() {
    var LastVisitedPrds = [];
    var lastPrdsKey = "LastVisitedPrds-" + $("#SmallCountryCode").val() + "-" + $("#SmallLangCode").val();

    if (typeof (Storage) !== "undefined") {
        if ($(".ProductHeader:first").length > 0 || $(".AutoGetLastVisited").length > 0) {
            var hours = 8; // Reset when storage is more than 24hours
            var now = new Date().getTime();
            var setupTime = localStorage.getItem('prdLastSetupTime');

            if (setupTime == null) {
                localStorage.setItem('prdLastSetupTime', now);
            } else {
                if (now - setupTime > hours * 60 * 60 * 1000) {
                    localStorage.removeItem(lastPrdsKey);
                    localStorage.setItem('prdLastSetupTime', now);
                }
            }

            var _productid = $("#ProductID:first").val();
            var _colorid = $("#ColorID:first").val();
            var _url = window.location.pathname;
            var _prdImg = $("#FirstAngle:first").val();//$("meta[property$=image]").attr("content");
            var _prdname = $(".ProductHeader:first").text();
            var _amount = $(".PriceItem:first").text();

            _prdname = _prdname.replace(/(\r\n|\n|\r)/gm, "").trim();

            LastVisitedPrds = GetLastVisitedData();

            var itemExist = false;

            for (var i = 0; i < LastVisitedPrds.length; i++) {
                if (LastVisitedPrds[i].ColorID == _colorid && LastVisitedPrds[i].ProductID == _productid) {
                    itemExist = true;
                }
            }

            if (!itemExist) {
                LastVisitedPrds.push({ Amount: _amount, ProductID: _productid, ColorID: _colorid, Url: _url, Img1: _prdImg, Img2: _prdImg, ProductName: _prdname });

                if (LastVisitedPrds.length > 6) {
                    LastVisitedPrds.shift();
                }

                localStorage.setItem(lastPrdsKey, JSON.stringify(LastVisitedPrds));
            }
        }
    }
}

function SlickSlider(SuggestedSlick) {
    var rtl = false;

    if ($("#SmallLangCode").val() == "ar") {
        rtl = true;
    }

    if (SuggestedSlick == "suggested") {
        if ($(".SuggestedProductsContainer.LastVisited .SuggestedProducts .ProductList .Prd").length > 3) {
            $(".SuggestedProductsContainer.LastVisited .SuggestedProducts .ProductList").slick({
                nextArrow: "<div class='PrdImgRight right-arrow'><i class='sorsfont sorsfont-right'></i></div>",
                prevArrow: "<div class='PrdImgLeft left-arrow'><i class='sorsfont sorsfont-left'></i></div>",
                infinite: true,
                slidesToShow: 3,
                slidesToScroll: 1,
                lazyLoad: 'ondemand',
                arrows: true,
                rtl: rtl,
                responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            infinite: true,
                            dots: true
                        }
                    }
                ]
            });
        }
        //else {
        //    $(".UseLazyLoadSuggested").Lazy();
        //}
    }
    else if (SuggestedSlick == "main") {
        UseSliderObject = "";

        if ($("#NewPd").hasClass("Combines")) {
            UseSliderObject = $('.ProductDetailImages ul');
        }
        else {
            UseSliderObject = $('.ProductDetailsMainImage ul');
        }

        // Main Slider
        UseSliderObject.slick({
            nextArrow: "<div class='PrdImgRight right-arrow'><i class='sorsfont sorsfont-right'></i></div>",
            prevArrow: "<div class='PrdImgLeft left-arrow'><i class='sorsfont sorsfont-left'></i></div>",
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            lazyLoad: 'ondemand',
            rtl: rtl,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: true
                    }
                }
            ]
        });

        $('.SmallProductImages ul').slick({
            slidesToShow: 5,
            slidesToScroll: 1,
            asNavFor: UseSliderObject,
            focusOnSelect: true,
            rtl: rtl
        });

    }
    else if (SuggestedSlick == "combine") {
        if ($(".SuggestedProductsContainer.CombineProduct .SuggestedProducts .ProductList .Prd").length > 3) {
            $(".SuggestedProductsContainer.CombineProduct .SuggestedProducts .ProductList").slick({
                nextArrow: "<div class='PrdImgRight right-arrow'><i class='sorsfont sorsfont-right'></i></div>",
                prevArrow: "<div class='PrdImgLeft left-arrow'><i class='sorsfont sorsfont-left'></i></div>",
                infinite: true,
                slidesToShow: 3,
                slidesToScroll: 1,
                //lazyLoad: 'ondemand',
                arrows: true,
                rtl: rtl,
                responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            infinite: true,
                            dots: true
                        }
                    }
                ]
            });
        }
        //else if ($(".SuggestedProductsContainer.CombineProduct .SuggestedProducts .ProductList .Prd").length > 0) {
        //    $(".SuggestedProductsContainer.CombineProduct .SuggestedProducts .ProductList .Prd").each(function () {
        //        $(this).find(".PImage").attr("src", $(this).find(".PImage").attr("data-lazy"));
        //    });
        //}
    }

    if (SuggestedSlick == "search") {
        if ($(".searchArea .SuggestedProductsContainer .AutoGetLastVisited .SuggestedProducts .ProductList .Prd").length > 3) {
            $(".searchArea .SuggestedProductsContainer .AutoGetLastVisited .SuggestedProducts .ProductList").slick({
                nextArrow: "<div class='PrdImgRight right-arrow'><i class='sorsfont sorsfont-right'></i></div>",
                prevArrow: "<div class='PrdImgLeft left-arrow'><i class='sorsfont sorsfont-left'></i></div>",
                infinite: true,
                slidesToShow: 4,
                slidesToScroll: 1,
                //lazyLoad: 'ondemand',
                arrows: true,
                rtl: rtl,
                responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            infinite: true,
                            dots: true
                        }
                    }
                ]
            });
        }
        //else {
        //    $(".searchArea .SuggestedProductsContainer .AutoGetLastVisited .SuggestedProducts .ProductList .UseLazyLoadSuggested").each(function () {
        //        var img = $(this).attr("data-lazy");
        //        if (img != null && img != "" && img != undefined) {
        //            $(this).attr("src", img);
        //        }
        //    });
        //}
    }
}

function SizeOperation() {
    $(document).on("click", ".js-size-options:not(.unselectable) > button", function () {
        $(".js-size-options").removeClass("selected");
        $(this).parent().addClass("selected");

        $(".js-add-to-cart").attr("data-sizeId", $(this).attr("data-id"));
        $("#SizeID").val($(this).attr("data-id")).trigger("change");
        $(".msg-error").html("");
    });

    $(document).on("change", "#SizeID", function () {
        $(".js-add-to-cart > span").html($(".js-add-to-cart").attr("data-text"));
    });

    $(document).on("click", ".js-add-to-cart", function () {
        var SizeID = $(this).attr("data-sizeId");
        var ColorID = $(this).attr("data-colorId");
        var ProductID = $(this).attr("data-productId");
        var Amount = 1;
        var LangID = $("#LangID").val();
        var AddingText = $(this).attr("data-adding");
        var errMsg = "";

        if (!SizeID)
            errMsg = $('#BedenSec').val();
        if (!ColorID)
            errMsg = $('#RenkSec').val();
        if (!ProductID)
            errMsg = $('#UrunYok').val();

        if (errMsg) {
            $(".msg-error").html(errMsg);
            return;
        }

        var basketButton = $(this);
        var NormalText = basketButton.text();
        basketButton.prop("disabled", true);
        basketButton.text(AddingText);

        GenerateLocalLoading($(".ProductDetail"), "show");
        var data = 'sizeID=' + SizeID + "&colorID=" + ColorID + "&productID=" + ProductID + "&adet=" + Amount + "&langID=" + LangID;

        AddToCard(data, function (dt) {
            basketButton.text(NormalText);
            basketButton.prop("disabled", false);
            GenerateLocalLoading($(".ProductDetail"), "hide");

            if (dt.Sonuc == true) {
                if (dt.Deger8 != '' && dt.Deger8 != null && dt.Deger8 != undefined) {
                    //#region DataLayer
                    var _dataLayerJSON = ExtractJSONFromString(dt.Deger8, 'DataLayer');

                    if (_dataLayerJSON != null && _dataLayerJSON != undefined && _dataLayerJSON != "") {
                        window.dataLayer = window.dataLayer || [];
                        dataLayer.push({ ecommerce: null });
                        dataLayer.push({
                            "event": "add_to_cart",
                            "ecommerce": {
                                currency: "TRY",
                                value: _dataLayerJSON.price,
                                "items": [_dataLayerJSON]
                            }
                        });
                    }
                    //#endregion DataLayer
                }

                if (dt.JsonRs != '' && dt.JsonRs != null && dt.JsonRs != undefined) {
                    //#region Klaviyo
                    if (window.klaviyo) {
                        var _klaviyoJSON = ExtractJSONFromString(dt.JsonRs, 'Klaviyo');
                        //console.log("_klaviyoJSON:", _klaviyoJSON);

                        if (_klaviyoJSON != null && _klaviyoJSON != undefined && _klaviyoJSON != "") {
                            klaviyo.push(["track", "Added to Cart", _klaviyoJSON]);
                        }
                    }
                    //#endregion Klaviyo
                }

                GetSepetIcerik(true);
            }
            else {
                SwalGenerate("error", dt.IslemSonucAciklama, getStandartMessages("Hata"), getStandartMessages("Kapat"));
            }
        });
    });
}

function swipperPd() {
    swiperPd = new Swiper('.pdp-gallery-main', {
        speed: 400,
        effect: "slide",
        autoplay: false,
        loop: true,
        slidesPerView: 1,
        spaceBetween: 0,
        navigation: {
            nextEl: '.js-swiper-button-next',
            prevEl: '.js-swiper-button-prev',
        },
    });
}

function FancyboxPd() {
    var isInfinite = false;

    if (isMobileResolution()) {
        var isInfinite = true;
    }

    Fancybox.bind('.swiper-slide [data-fancybox="mainImage"]', {
        hideScrollbar: true,
        backdropClick: false,
        contentClick: false,
        contentDblClick: "toggleMax",
        idle: false,
        mainClass: "pdp-fancybox-container",
        wheel: "slide",
        Thumbs: false,
        Carousel: {
            infinite: isInfinite,
            transition: "slide",
            on: {
                change: function (instance) {
                    $("#fancyZoomSlider").val(1);
                }
            }
        },
        Images: {
            Panzoom: {
                maxScale: 2,
                on: {
                    afterTransform: function (instance) {
                        var matrix = instance.getMatrix();
                        $("#fancyZoomSlider").val(matrix.a);
                    }
                }
            },
        },
        Toolbar: {
            items: {
                zoom: {
                    tpl: '<div class="fancy-zoom-slide-container"><input id="fancyZoomSlider" class="fancy-zoom-slide" type="range" min="1" max="2" step="0.1" value="1"><label>Drag to zoom</label></div>'
                },
            },
            display: {
                left: [],
                middle: ["zoom"],
                right: ["close"],
            },
        },
        on: {
            init: function (fancybox) {
                setTimeout(function () {
                    var rangeZoom = document.getElementById('fancyZoomSlider');
                    rangeZoom.addEventListener('input', function (event) {
                        fancybox.getSlide().panzoom.zoomTo(event.target.valueAsNumber)
                    });

                }, 500)
            }
        }
    });
}

function thumbnailSetting() {
    $(document).on("click", ".js-thumbnail-image", function () {
        var index = parseInt($(this).attr("data-index")) + 1;
        swiperPd.slideTo(index);

        //var element = $(this);
        //var indexNo = element.attr("data-index");
        //if (!indexNo) return;

        //var selectedImage = $(".js-swiper-slide[data-index='" + indexNo + "']");
        //if (!selectedImage) return;

        //$("html, body").stop().animate({ scrollTop: selectedImage.offset().top }, 500, 'swing', function () {
        //    //$(".js-thumbnail-image").removeClass("current");
        //    //element.addClass("current");
        //});
    });
}

$(document).ready(function () {
    if ($("body").hasClass("productdetails") && $("#PID").val()) {

        IsfollowForProductDetails($("#PID").val(), function (dt) {
            if (dt.IsFollow == true) {
                $(".js-favorites").addClass("active");
            }
        });

        GetSuggestedProducts();
        //SlickSlider("combine");
        //SlickSlider("main");
        FancyboxPd();
        swipperPd();

        if (!isMobileResolution())
            thumbnailSetting();

        //if (isMobileResolution()) {
        //    swipperPd();
        //}
        //else {
        //    thumbnailSetting();
        //}
    }

    if ($("body").hasClass("productdetails")) {
        var bodyStyles = document.body.style;
        bodyStyles.setProperty('--number-of-slides', $(".pdp-gallery-small > .thumbnail-image").length);

        document.addEventListener("scroll", function (event) {
            var lastKnownScrollPosition = window.scrollY;

            if (lastKnownScrollPosition >= 100) {
                $("body").addClass("is-scroll");
            } else {
                $("body").removeClass("is-scroll");
            }
        });

        SizeOperation();
    }

    $(document).on("click", ".js-favorites:not(.active)", function () {
        var ColorID = $(this).attr("data-colorId");
        var ProductID = $(this).attr("data-productId");
        var button = $(this);

        GenerateLocalLoading($(".ProductDetail"), "show");

        AddToFavorite(ColorID, ProductID, function (result, msg) {
            if (result == true) {
                button.addClass("active");

                //SwalGenerate("success", "", getStandartMessages("IslemBasarili"), getStandartMessages("Kapat"));
                setTimeout(function () {
                    if ($(".swal2-container .swal2-actions .swal2-confirm").length > 0) {
                        $(".swal2-container .swal2-actions .swal2-confirm").trigger("click");
                    }
                }, 3000);
            }
            else {
                var loginLink = getRequestRoute() + "/p/User/Login";
                SwalGenerate("warning", msg, getStandartMessages("IslemBasarisiz"), "<a href='" + loginLink + "'>" + getStandartMessages("GirisYap") + "</a>");
            }

            GenerateLocalLoading($(".ProductDetail"), "hide");
        });
    });

    $(document).on('click', '.rightModalBtn', function () {
        var cmpid = $(this).data('cmpid');

        $('#rightModal .card').hide();

        $('#rightModal .card.cmp-' + cmpid).show();
    });

    $(document).on("click", ".js-favorites.active", function () {
        var ProductID = $(this).attr("data-productId");
        var button = $(this);

        GenerateLocalLoading($(".ProductDetail"), "show");

        removeFavorite(ProductID, function (result) {
            if (result == true) {
                button.removeClass("active");

                //SwalGenerate("success", "", getStandartMessages("IslemBasarili"), getStandartMessages("Kapat"));
                setTimeout(function () {
                    if ($(".swal2-container .swal2-actions .swal2-confirm").length > 0) {
                        $(".swal2-container .swal2-actions .swal2-confirm").trigger("click");
                    }
                }, 3000);
            }
            else {
                SwalGenerate("error", getStandartMessages("BirHataOlustu"), getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
            }

            GenerateLocalLoading($(".ProductDetail"), "hide");
        });
    });
});
